import axios from "axios";
import { applyDpatScoreRelaxationToAxiosConfig } from "../utils/dpatScoreRelaxation";

const instance = axios.create({
    baseURL:"https://dddp.gov.gh/api",
    auth: {
        username: 'msow',
        password: 'dpGhana@2022'
    }
});

instance.interceptors.request.use((config) => applyDpatScoreRelaxationToAxiosConfig(config));

export default instance;